(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.updateNetSuiteBillingAccountIdsToNullModal',
      UpdateNetSuiteBillingAccountIdsToNullModalController
    );

  UpdateNetSuiteBillingAccountIdsToNullModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
  ];

  function UpdateNetSuiteBillingAccountIdsToNullModalController(
    $uibModalInstance, 
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.updateNetSuiteBillingAccountIdsToNull = updateNetSuiteBillingAccountIdsToNull;
    vm.cancel = cancel;

    function updateNetSuiteBillingAccountIdsToNull() {
      vm.saving += 1;
      debugToolsSvc
        .updateNetSuiteBillingAccountIdsToNull({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          billingAccountId: vm.billingAccountId
        })
        .success(() => {
          abp.notify.success(App.localize('Success'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
